import { IDBPDatabase } from 'idb';
import { atom } from 'jotai';

export const seanWebDbAtom = atom<IDBPDatabase | null>(null);
export const navigationBarTitleAtom = atom<string>('');
